import React from "react";
import { createPortal } from "react-dom";
import * as S from "./styles.ts";
import { BaseModalProps } from "./types.ts";
import { ModalPriorityEnum } from "../../../enums/ModalPriority.ts";
import CancelIcon from "@mui/icons-material/Cancel";

const BaseModal: React.FC<BaseModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  zIndex = ModalPriorityEnum.LOW,
}) => {
  if (!isOpen) return null;

  // Portal pra fora da árvore do DOM de qualquer <form> ancestral (mesmo
  // padrão de ui/Drawer.tsx) — sem isso, um <form> renderizado dentro deste
  // modal (ex: CadastroPaciente) fica aninhado dentro do <form> que abriu o
  // modal (ex: NovaCirurgiaForm), o que o React não suporta (gera erro de
  // hydration/DOM inválido no console) e faz o submit do form interno nunca
  // ser interceptado — o clique em "Cadastrar" cai no comportamento nativo
  // do navegador (GET pra URL atual com os campos do form na query string).
  return createPortal(
    <S.Overlay zIndex={zIndex}>
      <S.ModalContainer onClick={(e) => e.stopPropagation()}>
        <S.Header>
          <S.Title>{title}</S.Title>
          <S.Button onClick={onClose} aria-label="Fechar">
            <CancelIcon sx={{ color: "inherit" }} />
          </S.Button>
        </S.Header>
        <S.Content>{children}</S.Content>
      </S.ModalContainer>
    </S.Overlay>,
    document.body
  );
};

export default BaseModal;
